import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "./Seo";
import useLangPrefix from "../hooks/useLangPrefix";

interface IncomeClockPrivacyProps {
  lang: "de" | "en";
}

const IncomeClockPrivacy: React.FC<IncomeClockPrivacyProps> = ({ lang }) => {
  const { t } = useTranslation();
  const prefix = useLangPrefix();
  const p = (key: string) => t(`incomeClock.privacy.page.${key}`);

  return (
    <section className="imprint">
      <Seo
        lang={lang}
        path="/projekte/income-clock/datenschutz"
        title={t("incomeClock.privacy.seoTitle")}
        description={t("incomeClock.privacy.seoDescription")}
      />

      <a href={`${prefix}/projekte/income-clock`} className="ic-back">
        <i className="bx bx-arrow-back"></i> Income Clock
      </a>

      <h2 className="headings">{p("heading")}</h2>
      <div className="imprint-content">
        <p>
          <em>{t("incomeClock.privacy.updated")}</em>
        </p>

        <h3>{p("localHeading")}</h3>
        <p>{p("local1")}</p>
        <p>{p("local2")}</p>
        <p>{p("local3")}</p>

        <h3>{p("permHeading")}</h3>
        <p>{p("perm1")}</p>
        <p>{p("perm2")}</p>

        <h3>{p("thirdHeading")}</h3>
        <h4>{p("admobTitle")}</h4>
        <p>{p("admob1")}</p>
        <p>{p("admobConsent1")}</p>
        <p>{p("admobConsent2")}</p>
        <p>{p("admob2")}</p>
        <p>
          {p("admob3pre")}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            {p("admob3link1")}
          </a>
          {p("admob3mid")}
          <a
            href="https://policies.google.com/technologies/ads"
            target="_blank"
            rel="noopener noreferrer"
          >
            {p("admob3link2")}
          </a>
          {p("admob3post")}
        </p>

        <h4>{p("iapTitle")}</h4>
        <p>{p("iap1")}</p>

        <h4>{p("trackTitle")}</h4>
        <p>{p("track1")}</p>

        <h3>{p("rightsHeading")}</h3>
        <p>{p("rights1")}</p>
        <p>{p("rights2")}</p>

        <h3>{p("respHeading")}</h3>
        <p>{p("respBody")}</p>
      </div>
    </section>
  );
};

export default IncomeClockPrivacy;
